var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#FF9FD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 11.3399C26.5083 12.2107 27.7629 13.4604 28.6398 14.9652C29.5167 16.47 29.9854 18.1777 29.9994 19.9192C30.0135 21.6608 29.5725 23.3758 28.72 24.8946C27.8676 26.4133 26.6332 27.6831 25.1392 28.5782C23.6452 29.4733 21.9434 29.9627 20.2021 29.998C18.4608 30.0332 16.7406 29.6131 15.2116 28.7791C13.6826 27.9452 12.3979 26.7264 11.4847 25.2434C10.5715 23.7604 10.0614 22.0646 10.005 20.3239L10 19.9999L10.005 19.6759C10.061 17.9489 10.5635 16.2659 11.4636 14.7909C12.3637 13.3159 13.6307 12.0993 15.1409 11.2598C16.6511 10.4202 18.3531 9.98629 20.081 10.0003C21.8089 10.0144 23.5036 10.4759 25 11.3399ZM20 13.9999C19.7551 13.9999 19.5187 14.0898 19.3356 14.2526C19.1526 14.4154 19.0357 14.6396 19.007 14.8829L19 14.9999V19.9999L19.009 20.1309C19.0318 20.3044 19.0997 20.4689 19.206 20.6079L19.293 20.7079L22.293 23.7079L22.387 23.7899C22.5624 23.926 22.778 23.9998 23 23.9998C23.222 23.9998 23.4376 23.926 23.613 23.7899L23.707 23.7069L23.79 23.6129C23.9261 23.4375 23.9999 23.2219 23.9999 22.9999C23.9999 22.7779 23.9261 22.5623 23.79 22.3869L23.707 22.2929L21 19.5849V14.9999L20.993 14.8829C20.9643 14.6396 20.8474 14.4154 20.6644 14.2526C20.4813 14.0898 20.2449 13.9999 20 13.9999Z",
    fill: "#FF3093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a39ed952a2c8cfa51aff40fda572abd5.svg";
export { ForwardRef as ReactComponent };